export enum CubeTimeDimensionGranularity {
  Day = 'day',
  Week = 'week',
  Month = 'month',
}
